export const COPY_STATES = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed',
  SUCCESS: 'succeeded',
};